import GLightbox from "glightbox";

const initLightbox = ()=> {

    const lightbox = GLightbox({
        selector: '[data-glightbox]',
    });

    const lightboxVideo = GLightbox({
        selector: '[data-glightbox-video]',
        type: 'video',
        source: 'youtube', //vimeo, youtube or local
        videosWidth: 1400,
        autoplayVideos: false,
    });

}

export default initLightbox;
